import React from 'react';
import {
  ButtonDropdown,
  ButtonDropdownItem,
  FlexView,
} from '@gsa/afp-component-library';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

export const CONTRACT_ACTIONS = {
  SEARCH_CONTRACTS: {
    label: 'Search contracts',
    customIcon: true,
    icon: 'search',
    getUrl: () => {
      return `/catalog/contract`;
    },
  },
  VIEW_CONTRACT: {
    label: 'View contract',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}`;
    },
  },
  VIEW_CONTRACT_VERSION: {
    label: 'View contract',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId, versionNumber }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}/history/${versionNumber}`;
    },
  },
  VIEW_LATEST_CONTRACT_VERSION: {
    label: 'View latest contract version',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}`;
    },
  },
  VIEW_CONTRACT_HISTORY: {
    label: 'View contract history',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}/history`;
    },
  },
  VIEW_CONTRACT_LINE_LISTING: {
    label: 'View contract line listing',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}/lines`;
    },
  },
  VIEW_LATEST_CONTRACT_LINE_VERSION: {
    label: 'View latest contract line version',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId, contractLineId }) => {
      return `/catalog/contract/${contractHeaderId}/contract-line-template/${contractLineId}`;
    },
  },
  VIEW_CONTRACT_LINE_HISTORY: {
    label: 'View contract line history',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId, contractLineId }) => {
      return `/catalog/contract/${contractHeaderId}/contract-line-template/${contractLineId}/history`;
    },
  },
  BACK_TO_CONTRACT_HISTORY: {
    label: 'Back to contract history',
    customIcon: true,
    icon: 'arrow_back',
    getUrl: ({ contractHeaderId }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}/history`;
    },
  },
  VIEW_CONTRACT_VERSION_LISTING: {
    label: 'View contract line listing',
    customIcon: true,
    icon: 'visibility',
    getUrl: ({ contractHeaderId, versionNumber }) => {
      return `/catalog/contract/contract-header/${contractHeaderId}/history/${versionNumber}/lines`;
    },
  },
  ADD_CONTRACT_LINE: {
    label: 'Add contract line',
    customIcon: true,
    icon: 'add',
    onClickHandler: () => {},
  },
  IMPORT_AWARDED_BID_LINES: {
    label: 'Import awarded bid lines',
    customIcon: true,
    icon: 'arrow_downward',
    onClickHandler: () => {},
  },
  EDIT_VEHICLE_SUPPLIER_UEI: {
    label: `Edit vehicle supplier's UEI`,
    customIcon: true,
    icon: 'edit',
    onClickHandler: null, // Will be set dynamically
  },
};

export const ContractActions = ({
  actions,
  contractHeaderId,
  contractLineId,
  versionNumber,
  onUpdateUeiClick,
}) => {
  const navigate = useNavigate();

  return (
    <FlexView hAlignContent="right">
      <ButtonDropdown
        className="margin-right-0 margin-bottom-1"
        variant="outline"
        label="Actions"
        side="right"
      >
        {actions.filter(Boolean).map((action) => {
          const getClickHandler = () => {
            if (action.label === `Edit vehicle supplier's UEI`) {
              return onUpdateUeiClick;
            }
            if (action.onClickHandler) {
              return action.onClickHandler;
            }
            return () => {
              navigate(
                action.getUrl({
                  contractHeaderId,
                  contractLineId,
                  versionNumber,
                }),
              );
            };
          };

          return (
            <React.Fragment key={action.label}>
              <ButtonDropdownItem
                className="text-primary hover:bg-blue-5"
                label={action.label}
                iconName={action.icon}
                iconType={action.customIcon && 'custom'}
                iconFill="#005ea2"
                onClick={getClickHandler()}
              />
            </React.Fragment>
          );
        })}
      </ButtonDropdown>
    </FlexView>
  );
};

ContractActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
  contractHeaderId: PropTypes.string,
  contractLineId: PropTypes.string,
  versionNumber: PropTypes.string,
  onUpdateUeiClick: PropTypes.func,
};
